import type { RouteObject } from "react-router-dom";

import { Protected } from "@dzambalaorg/common-pages";
import {
  IndexWrapper,
  MysterySection,
  MysteryBox,
  MysteryContract,
  MysteryToken,
  ServiceType,
} from "@framework/shared";

export const mysteryRoutes: Array<RouteObject> = [
  {
    path: "/mystery",
    children: [
      {
        index: true,
        element: (
          <IndexWrapper index="mystery">
            <MysterySection service={ServiceType.ADMIN} />
          </IndexWrapper>
        ),
      },
      {
        path: "/mystery/contracts",
        element: <Protected />,
        children: [
          { index: true, element: <MysteryContract service={ServiceType.ADMIN} /> },
          { path: "/mystery/contracts/:id/:action", element: <MysteryContract service={ServiceType.ADMIN} /> },
        ],
      },
      {
        path: "/mystery/boxes",
        element: <Protected />,
        children: [
          { index: true, element: <MysteryBox service={ServiceType.ADMIN} /> },

          { path: "/mystery/boxes/:id/:action", element: <MysteryBox service={ServiceType.ADMIN} /> },
        ],
      },
      {
        path: "/mystery/tokens",
        element: <Protected />,
        children: [
          { index: true, element: <MysteryToken service={ServiceType.ADMIN} /> },

          { path: "/mystery/tokens/:id/:action", element: <MysteryToken service={ServiceType.ADMIN} /> },
        ],
      },
    ],
  },
];
